import { PaneItem } from '@/components/pane/types';

export const integrationConfig: PaneItem[] = [
  {
    icon: require('../public/static/images/python-logo.png'),
    label: 'Python',
    language: 'python',
    codeSnippet: `with exa.Session("exa-cluster") as sess:
    model = sess.NewModule("Detector:v1.0")
    image = sess.from_numpy(...)
    outputs = model.run(image=image)
    print(outputs["boxes"].numpy())`,
  },
  {
    icon: require('../public/static/images/cpp-logo.png'),
    label: 'C++',
    language: 'cpp',
    codeSnippet: `Session sess(SessionConfig{"exa-cluster"});
Module model = sess.NewModule("Detector:v1.0");
Tensor image = sess.ZeroedTensor(DataType::FLOAT32, ...);
ValueMap outs = model.Run({{"image", image}});
float* boxes = outs["boxes"].AsTensor().Data<float>();`,
    codeSnippetNarrow: `Session sess(
    SessionConfig{"exa-cluster"});
Module model = sess.NewModule(
    "Detector:v1.0");
Tensor image = sess.ZeroedTensor(
    DataType::FLOAT32, ...);
ValueMap outs = model.Run(
    {{"image", image}});
float* boxes = outs["boxes"]
    .AsTensor().Data<float>();`,
  },
];
